import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonsModule } from '../commons/commons.module';
import { MapModule } from '../map/map.module';
import { UiScrollModule } from 'ngx-ui-scroll';
import { DatePicker } from 'primeng/datepicker';
import { LottieComponent } from 'ngx-lottie';

import { BokComponent } from './bok/bok.component';
import { NotFoundComponent } from './notfound/not-found.component';
import { PanelComponent } from './panel/panel.component';
import { CommonPlaceholderComponent } from './placeholders/common/common-placeholder.component';

import { VehiclePanelLiteComponent } from './vehicle/list-lite/vehicle-panel-lite.component';
import { VehicleListLiteItemComponent } from './vehicle/list-lite/item/vehicle-list-lite-item.component';
import { VehicleListFullComponent } from './vehicle/list-full/vehicle-list-full.component';
import { VehicleListFullConfigComponent } from './vehicle/list-full/config/vehicle-list-full-config.component';
import { VehicleListFullIndicatorStatusHeaderComponent } from './vehicle/list-full/headers/indicator-status/vehicle-list-full-indicator-status-header.component';
import { VehicleListFullIndicatorValueHeaderComponent } from './vehicle/list-full/headers/indicator-value/vehicle-list-full-indicator-value-header.component';
import { VehicleListFullTachoHeaderComponent } from './vehicle/list-full/headers/tacho/vehicle-list-full-tacho-header.component';
import { VehicleListFullItemComponent } from './vehicle/list-full/item/vehicle-list-full-item.component';
import { VehicleListFilterComponent } from './vehicle/filter/vehicle-list-filter.component';
import { VehicleDetailsComponent } from './vehicle/details/vehicle-details.component';
import { VehicleDetailsHeaderComponent } from './vehicle/details/header/vehicle-details-header.component';
import { VehicleDetailsTabsComponent } from './vehicle/details/tabs/vehicle-details-tabs.component';
import { VehicleDetailsEcoTabComponent } from './vehicle/details/tabs/eco/vehicle-details-eco-tab.component';
import { VehicleDetailsParamsTabComponent } from './vehicle/details/tabs/params/vehicle-details-params-tab.component';
import { VehicleDetailsRoutesTabComponent } from './vehicle/details/tabs/routes/vehicle-details-routes-tab.component';
import { VehicleDetailsTachoTabComponent } from './vehicle/details/tabs/tacho/vehicle-details-tacho-tab.component';
import { VehicleDetailsETollTabComponent } from './vehicle/details/tabs/e-toll/vehicle-details-etoll-tab.component';
import { VehicleControlIndicatorValueComponent } from './vehicle/control-value/vehicle-control-indicator-value.component';
import { VehicleLocationComponent } from './vehicle/location/vehicle-location.component';
import { VehicleCurrentDriverComponent } from './vehicle/details/header/current-driver/vehicle-current-driver.component';
import { VehicleControlIndicatorSignalValueComponent } from './vehicle/control-value/singnal-value/vehicle-control-indicator-signal-value.component';
import { VehicleControlIndicatorValueTypeComponent } from './vehicle/control-value/control-value-type/vehicle-control-indicator-value-type.component';

import { DriverListLiteComponent } from './driver/list-lite/driver-list-lite.component';
import { DriverDetailsComponent } from './driver/details/driver-details.component';
import { DriverDetailsHeaderComponent } from './driver/details/header/driver-details-header.component';
import { DriverDetailsTabsComponent } from './driver/details/tabs/driver-details-tabs.component';
import { DriverDetailsEcoTabComponent } from './driver/details/tabs/eco/driver-details-eco-tab.component';
import { DriverDetailsTachoTabComponent } from './driver/details/tabs/tacho/driver-details-tacho-tab.component';
import { DriverTachoSlotDetailsComponent } from './driver/details/tabs/tacho/details/driver-tacho-slot-details.component';

import { NotificationComponent } from './notification/notification.component';

import { EventListLiteComponent } from './event/list-lite/event-list-lite.component';

import { AreaListLiteComponent } from './area/list-lite/area-list-lite.component';
import { AreaListFilterComponent } from './area/filter/area-list-filter.component';
import { AreaCreateComponent } from './area/create/area-create.component';
import { AreaListItemComponent } from './area/list-lite/item/area-list-item.component';
import { AreaFormComponent } from './area/form/area-form.component';
import { AreaFormInputComponent } from './area/form/input/area-form-input.component';
import { PipesModule } from '../commons/pipes/pipes.module';
import { VehicleDetailsRouteItemComponent } from './vehicle/details/tabs/routes/item/vehicle-details-route-item.component';
import { VehicleDetailsRouteStatsComponent } from './vehicle/details/tabs/routes/stats/vehicle-details-route-stats.component';
import { VehicleListFullExpandComponent } from './vehicle/list-full/expand/vehicle-list-full-expand.component';
import { ScrollBarModule } from '@commons/forms/scroll-bar/scroll-bar.module';
import { AreaDeleteComponent } from './area/delete/area-delete.component';
import { VehicleLastUpdatedComponent } from './vehicle/details/header/last-updated/vehicle-last-updated.component';
import { VehicleSignalLostComponent } from './vehicle/details/header/signal-lost/vehicle-signal-lost.component';
import { VehicleTachoDetailsComponent } from './vehicle/details/tabs/tacho/details/vehicle-tacho-details.component';
import { VehicleTachoDriverComponent } from './vehicle/details/tabs/tacho/driver/vehicle-tacho-driver.component';
import { VehicleTachoStatusComponent } from './vehicle/details/tabs/tacho/status/vehicle-tacho-status.component';
import { VehicleListFullInidicatorColumnFullComponent } from './vehicle/list-full/headers/indicator-column-full/vehicle-list-full-inidicator-column-full.component';

import { ETollBalanceComponent } from './vehicle/list-lite/etoll-panel/etoll-balance/e-toll-balance.component';
import { ETollItemComponent } from './vehicle/list-lite/etoll-panel/etoll-item/e-toll-item.component';
import { ActivateETollComponent } from './vehicle/list-lite/etoll-panel/activate-etoll/activate-e-toll.component';

import {SharedModule} from "@shared/shared.module";
import {UserProfileModule} from "@user-profile/user-profile.module";
import { HelpModule } from '@help/help.module';
import { TooltipModule } from 'primeng/tooltip';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RadioButtonModule } from 'primeng/radiobutton';
import {TranslateModule} from "@ngx-translate/core";
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import {CalendarModule} from 'primeng/calendar';

import { NoETollDataComponent } from './vehicle/list-lite/etoll-panel/no-etoll-data/no-etoll-data.component';
import { ETollBalanceFooterComponent } from './vehicle/list-lite/etoll-panel/etoll-balance-footer/etoll-balance-footer.component';
import { DirectivesModule } from '@commons/directives/directives.module';

import {DataSharingModule} from "@data-sharing/data-sharing.module";
import { SidePanelContainerComponent } from './side-panel-container/side-panel-container.component';
import { FullPanelContainerComponent } from './full-panel-container/full-panel-container.component';
import {
  DriverDetailsDataTabComponent
} from "@layout/driver/details/tabs/driver-details-data-tab/driver-details-data-tab.component";
import {
  DriverDeactivationModalComponent
} from "@layout/driver/details/tabs/driver-details-data-tab/driver-deactivation-modal/driver-deactivation-modal.component";
import { DriverUnarchiveModalComponent } from './driver/details/tabs/driver-details-data-tab/driver-unarchive-modal/driver-unarchive-modal.component';
import { DriverListItemComponent } from './driver/list-lite/driver-list-item/driver-list-item.component';
import {MapPanelModule} from "@src/app/map-panel/map-panel.module";
import {HandoverModule} from "@handover/handover.module";
import { LoadingInitialDataComponent } from './panel/components/loading-initial-data/loading-initial-data.component';
import { VehicleListComponent } from './vehicle/list-lite/vehicle-list/vehicle-list.component';
import { AreasModule } from './areas/areas.module';
import { EtollDropdownBalanceComponent } from './panel/components/etoll-dropdown-balance/etoll-dropdown-balance.component';
import { RightPanelContainerComponent } from './right-panel-container/right-panel-container.component';
import { ListVehicleItemComponent } from './vehicle/components/list-vehicle-item/list-vehicle-item.component';
import { FilterControlComponent } from './vehicle/filter/filter-control/filter-control.component';
import { ConfiguratorListVehicleComponent } from './vehicle/components/configurator-list-vehicle/configurator-list-vehicle.component';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from 'primeng/progressbar';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ThVehicleDetailsLocksTabComponent } from './vehicle/details/tabs/th-vehicle-details-locks-tab/th-vehicle-details-locks-tab.component';
import {MatDialogModule} from '@angular/material/dialog';
import { ETollDisableModalComponent } from './vehicle/details/tabs/e-toll/e-toll-disable-modal/e-toll-disable-modal.component';
import { SkeletonModule } from 'primeng/skeleton';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { VehicleTachoSlotsComponent } from './vehicle/details/tabs/tacho/vehicle-tacho-slots/vehicle-tacho-slots.component';
import { DriverTachoComponent } from './vehicle/details/tabs/tacho/driver-tacho/driver-tacho.component';
import { TachoSummaryDataComponent } from './vehicle/details/tabs/tacho/tacho-summary-data/tacho-summary-data.component';
import { TachoDataDetailsComponent } from './vehicle/details/tabs/tacho/tacho-data-details/tacho-data-details.component';
import { TachoEmptyStateComponent } from './vehicle/details/tabs/tacho/tacho-empty-state/tacho-empty-state.component';
import { SentTabComponent } from './vehicle/details/tabs/sent-tab/sent-tab.component';
import { SentTabNoActiveServiceComponent } from './vehicle/details/tabs/sent-tab/sent-tab-no-active-service/sent-tab-no-active-service.component';
import { ListVehicleTachoItemComponent } from './vehicle/list-lite/list-vehicle-tacho-item/list-vehicle-tacho-item.component';
import { SentDisableModalComponent } from './vehicle/details/tabs/sent-tab/sent-disable-modal/sent-disable-modal.component';
import { VehicleDetailsRoutesCalendarComponent } from './vehicle/details/tabs/routes/vehicle-details-routes-calendar/vehicle-details-routes-calendar.component';
import { VehicleDetailsRouteSummaryDataComponent } from './vehicle/details/tabs/routes/vehicle-details-route-summary-data/vehicle-details-route-summary-data.component';
import { VehicleDetailsRoutesDaysSwitchComponent } from './vehicle/details/tabs/routes/vehicle-details-routes-days-switch/vehicle-details-routes-days-switch.component';
import { AdsModule } from '@shared/components/ads/ads.module';
import { NewsModule } from './news/news.module';
import { EventListComponent } from './event/list-lite/event-list/event-list.component';
import { EventItemComponent } from './event/list-lite/event-list/alarm-item/event-item.component';
import { FuelItemComponent } from './event/list-lite/event-list/fuel-item/fuel-item.component';
import { AreaItemComponent } from './event/list-lite/event-list/area-item/area-item.component';
import { DatepickerEventComponent } from './event/list-lite/filters/datepicker-event/datepicker-event.component';
import { FiltersEventsComponent } from './event/list-lite/filters/filters-events/filters-events.component';
import { EventListItemInfoComponent } from './event/list-lite/event-list/info/event-list-item-info.component';
import { DropdownMenuComponent } from '@shared/standalone/dropdown-menu/dropdown-menu.component';
import { WorkersComponent } from '../views/directories/workers/workers.component';
import { WorkersAddFormComponent } from '../views/directories/workers/workers-add-form/workers-add-form.component';
import { GroupRoutesByDatePipe } from '@shared/pipes/group-routes-by-date.pipe';
import { FormatDatePipe } from '@shared/pipes/format-date.pipe';
import { NetworkTypeMarkerComponent } from '../standalone-components/network-type-marker/network-type-marker.component';
import { NetworkWarrningComponent } from '../standalone-components/network-warrning/network-warrning.component';
import { VehicleBusinessNumberPinComponent } from '../standalone-components/vehicle-business-number-pin/vehicle-business-number-pin.component';
import { ParameterCarsChartComponent } from '../views/parameter-cars-chart/parameter-cars-chart.component';
import { RouteReportsComponent } from '../views/route-reports/route-reports.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    CommonsModule,
    MapModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    ScrollBarModule,
    SharedModule,
    UserProfileModule,
    HelpModule,
    TranslateModule,
    DataSharingModule,
    MapPanelModule,
    HandoverModule,
    AreasModule,
    PipesModule,
    TooltipModule,
    OverlayPanelModule,
    RadioButtonModule,
    DirectivesModule,
    ButtonModule,
    CheckboxModule,
    InputTextModule,
    ProgressBarModule,
    InputSwitchModule,
    MatDialogModule,
    SkeletonModule,
    ProgressSpinnerModule,
    CalendarModule,
    AdsModule,
    NewsModule,
    UiScrollModule,
    DropdownMenuComponent,
    WorkersComponent,
    WorkersAddFormComponent,
    GroupRoutesByDatePipe,
    FormatDatePipe,
    DatePicker,
    NetworkTypeMarkerComponent,
    NetworkWarrningComponent,
    VehicleBusinessNumberPinComponent,
    ParameterCarsChartComponent,
    LottieComponent,
    RouteReportsComponent,
  ],
  declarations: [
    CommonPlaceholderComponent,
    BokComponent,
    NotFoundComponent,
    PanelComponent,
    VehiclePanelLiteComponent,
    VehicleListLiteItemComponent,
    VehicleListFullComponent,
    VehicleListFullConfigComponent,
    VehicleDetailsComponent,
    VehicleDetailsHeaderComponent,
    VehicleDetailsTabsComponent,
    VehicleDetailsEcoTabComponent,
    VehicleDetailsParamsTabComponent,
    VehicleDetailsRoutesTabComponent,
    VehicleDetailsTachoTabComponent,
    VehicleTachoDetailsComponent,
    VehicleTachoDriverComponent,
    VehicleTachoStatusComponent,
    VehicleDetailsETollTabComponent,
    VehicleCurrentDriverComponent,
    VehicleListFilterComponent,
    VehicleListFullItemComponent,
    VehicleControlIndicatorValueComponent,
    VehicleControlIndicatorSignalValueComponent,
    VehicleListFullIndicatorStatusHeaderComponent,
    VehicleListFullIndicatorValueHeaderComponent,
    VehicleListFullTachoHeaderComponent,
    VehicleLocationComponent,
    VehicleControlIndicatorValueTypeComponent,
    DriverListLiteComponent,
    DriverDetailsComponent,
    DriverDetailsHeaderComponent,
    DriverDetailsTabsComponent,
    DriverDetailsEcoTabComponent,
    DriverDetailsTachoTabComponent,
    DriverTachoSlotDetailsComponent,
    NotificationComponent,
    EventListLiteComponent,
    EventListItemInfoComponent,
    AreaListLiteComponent,
    AreaListFilterComponent,
    AreaCreateComponent,
    AreaListItemComponent,
    AreaFormComponent,
    AreaFormInputComponent,
    VehicleDetailsRouteItemComponent,
    VehicleDetailsRouteStatsComponent,
    VehicleListFullExpandComponent,
    AreaDeleteComponent,
    VehicleLastUpdatedComponent,
    VehicleSignalLostComponent,
    VehicleListFullInidicatorColumnFullComponent,
    ETollBalanceComponent,
    ETollItemComponent,
    ActivateETollComponent,
    NoETollDataComponent,
    ETollBalanceFooterComponent,
    SidePanelContainerComponent,
    FullPanelContainerComponent,
    DriverDetailsDataTabComponent,
    DriverDeactivationModalComponent,
    DriverUnarchiveModalComponent,
    DriverListItemComponent,
    LoadingInitialDataComponent,
    VehicleListComponent,
    EtollDropdownBalanceComponent,
    RightPanelContainerComponent,
    ListVehicleItemComponent,
    FilterControlComponent,
    ConfiguratorListVehicleComponent,
    ThVehicleDetailsLocksTabComponent,
    ETollDisableModalComponent,
    VehicleTachoSlotsComponent,
    DriverTachoComponent,
    TachoSummaryDataComponent,
    TachoDataDetailsComponent,
    TachoEmptyStateComponent,
    SentTabComponent,
    SentTabNoActiveServiceComponent,
    ListVehicleTachoItemComponent,
    SentDisableModalComponent,
    VehicleDetailsRoutesCalendarComponent,
    VehicleDetailsRouteSummaryDataComponent,
    VehicleDetailsRoutesDaysSwitchComponent,
    EventListComponent,
    EventItemComponent,
    FuelItemComponent,
    AreaItemComponent,
    DatepickerEventComponent,
    FiltersEventsComponent,
  ],
  exports: [
    NotFoundComponent,
    PanelComponent,
    NotificationComponent,
    BokComponent,
]
})
export class LayoutModule {

}
